// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__mDcvJ","menuItemSelected":"MenuItem_menuItemSelected__Fvbcw"};